/** @format */

import { ComponentType } from "react";
import ErrorBoundary from "../../api/ErrorBoundary";
import useRedirectAuthHooks from "../../hooks/useRedirectAuthHooks";

const RedirectBeforeRender = ({ Component, redirect }: { Component: ComponentType<any>; redirect?: boolean }) => {
  const { RedirectAuthCheck } = useRedirectAuthHooks();
  if (!RedirectAuthCheck()) return null;
  return (
    <ErrorBoundary>
      <Component redirect={redirect} />
    </ErrorBoundary>
  );
};

export default RedirectBeforeRender;
